window.pikiforms_lead_inline_message = function ($form, jSon) {

    var isSuccess = typeof jSon.message === 'string'
    var message = isSuccess ? jSon.message : $form.data('errors-general-message')

    if (!message) {
        return
    }

    var $status = $form.find('div.form-status')
    if (!$status.length) {
        $status = jQuery('<div class="status form-status inline"><div class="content"></div></div>').hide()
        $status.prependTo($form)
    }

    $status
        .stop()
        .removeClass('error success alert')
        .addClass(isSuccess ? 'success' : 'error')
        .children('.content')
        .html(message)

    $status.slideDown()

    // Volta o form para o estado inicial ao clicar em "Preencher novamente"
    $status.off('click.retry').on('click.retry', 'button.retry-form', function () {
        $status.removeClass('error').slideUp()
    })

    var $wrapper = $form.closest('.newsletter')
    if ($wrapper.length) {
        PikiForms.setScroll($wrapper.offset().top)
    }

}

// Igual ao handler do "lead", mas sem rolar a página, pois na Carta do Dia
// o scroll corta o texto da página.
window.pikiforms_carta_inline_message = function ($form, jSon) {

    var isSuccess = typeof jSon.message === 'string'
    var message = isSuccess ? jSon.message : $form.data('errors-general-message')

    if (!message) {
        return
    }

    var $status = $form.find('div.form-status')
    if (!$status.length) {
        $status = jQuery('<div class="status form-status inline"><div class="content"></div></div>').hide()
        $status.prependTo($form)
    }

    $status
        .stop()
        .removeClass('error success alert')
        .addClass(isSuccess ? 'success' : 'error')
        .children('.content')
        .html(message)

    $status.slideDown()

    // Volta o form para o estado inicial ao clicar em "Preencher novamente"
    $status.off('click.retry').on('click.retry', 'button.retry-form', function () {
        $status.removeClass('error').slideUp()
    })

}

class NewsletterForm {

    constructor(wrapper) {

        this.wrapper = wrapper
        this.form = wrapper.querySelector('form.PikiForm')

        if (!this.form) {
            return
        }

        const observer = new MutationObserver(() => this.toggleStatus())

        observer.observe(this.form, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true
        })

    }

    toggleStatus() {

        const status = this.form.querySelector('.form-status.inline')
        const state = status ? status.classList.contains('success') || status.classList.contains('error') : false

        this.wrapper.classList.toggle('form-sent', state)

    }

}

window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.newsletter').forEach((wrapper) => {
        new NewsletterForm(wrapper)
    })
});
